// Card color constants
export const cardColors = {
  selected: {
    background: "bg-[#809be1]",
    border: "border-[#D9E3FC]",
  },
  default: {
    background: "bg-[#F2F7FA]",
  },
} as const;

// Type definitions for better type safety
export type CardColorKeys = keyof typeof cardColors;
export type CardColorValues = (typeof cardColors)[CardColorKeys];
